import { Suspense } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import IncomeCalculator from '@/components/IncomeCalculator';
import Header from '@/components/Header';
import ThanksPage from '@/pages/thanks';

function App() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div className="min-h-screen bg-[#fafafa] flex items-center justify-center">Loading...</div>}>
        <div className="min-h-screen bg-[#fafafa]">
          <Header/>
          <div className="h-2 bg-gradient-to-r from-[#006b69] via-[#ccd77b] to-[#ffd767]"></div>
          <main className="container mx-auto px-4 py-8">
            <Routes>
              <Route path="/" element={<IncomeCalculator/>} />
              <Route path="/thanks" element={<ThanksPage/>} />
            </Routes>
          </main>
        </div>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
